import React from "react";
import styled from "styled-components";

export const PromoBoxWrapper = styled.section`
  img.center-block {
    display: block;
    text-align: center;
    margin: 60px auto;
  }
`;

const PromoBox = (props) => (
  <PromoBoxWrapper>
    {props.id === "motw" && (
      <div key={props.motw.id}>
        <span>
          <strong>Mix of the Week:</strong>
        </span>
        <a href={props.motw.url} target="_blank" rel="noopener noreferrer" onClick={() => window.gtag('event', 'totd_click', { eventLabel: `Tracks Right Nav: MOTW ${props.motw.dj}` })}>
          <img src={`//dreamchimney.com/motw/img/mixes-new/${props.motw["motw-series-number"]}.jpg`} className="img-fluid" alt="MOTW" />
        </a>
        <span className="promo-title">
          <a href={props.motw.url} target="_blank" rel="noopener noreferrer" onClick={() => window.gtag('event', 'totd_click', { eventLabel: `Tracks Right Nav: MOTW ${props.motw.dj}` })}>
            "{props.motw.title}" mixed by {props.motw.dj}
          </a>
        </span>
      </div>
    )}
    {props.id === "promo" && (
      <div className="mb-promo-box" key={props.promoTrack.id}>
        <a target="_blank" rel="noopener noreferrer" href={`//www.dreamchimney.com/promo/${props.promoTrack.slug}`} onClick={() => window.gtag('event', 'totd_click', { eventLabel: `Tracks Right Nav: Promo ${props.promoTrack.artist}` })}>
          <div
            className="bg"
            style={{
              backgroundImage: `url(//dreamchimney.com/tracks/images/promo-tracks/${props.promoTrack.id}.jpg)`,
            }}
          />
          <span>
            DC Promo Tracks #{props.promoTrack.id}:<br />
            {props.promoTrack.artist} "{props.promoTrack.title}"
          </span>
        </a>
      </div>
    )}
  </PromoBoxWrapper>
);

export default PromoBox;
